import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';
import { ApiService } from '../common/api.service';
import { CreateLoginNoticeDTO } from '@core/models/dto';

@Injectable({
  providedIn: 'root',
})
export class LoginNoticeService {
  constructor(private readonly http: ApiService) {
  }

  getAll() {
    return this.http.get(
      API_ENDPOINT.loginNotice.controller + API_ENDPOINT.loginNotice.getAll,
    );
  }

  getDetail(id: number) {
    return this.http.get(
      API_ENDPOINT.loginNotice.controller + API_ENDPOINT.loginNotice.getDetail + id,
    );
  }

  createFinal(data: CreateLoginNoticeDTO) {
    const dto = this.prepareCreateHelpDTO(data);
    return this.http.post(
      API_ENDPOINT.loginNotice.controller + API_ENDPOINT.loginNotice.createFinal,
      dto,
    );
  }

  createDraft(data: CreateLoginNoticeDTO) {
    const dto = this.prepareCreateHelpDTO(data);
    return this.http.post(
      API_ENDPOINT.loginNotice.controller + API_ENDPOINT.loginNotice.createDraft,
      dto,
    );
  }

  update(data: CreateLoginNoticeDTO, id: number) {
    const dto = this.prepareCreateHelpDTO(data);
    return this.http.put(
      API_ENDPOINT.loginNotice.controller + API_ENDPOINT.loginNotice.update + id,
      dto,
    );
  }

  delete(id: number) {
    return this.http.delete(
      API_ENDPOINT.loginNotice.controller + id,
    );
  }

  private prepareCreateHelpDTO(data: CreateLoginNoticeDTO): CreateLoginNoticeDTO {
    if (data.startDatetime) {
      data.startDatetime = this.setDateSeconds(data.startDatetime);
    }
    if (data.endDatetime) {
      data.endDatetime = this.setDateSeconds(data.endDatetime, true);
    }
    return data;
  }

  private setDateSeconds(date: Date, isEndDate = false) {
    if (isEndDate) {
      return new Date(new Date(date).setSeconds(59, 99));
    } else {
      return new Date(new Date(date).setSeconds(0, 0));
    }
  }
}
